import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@atoms';

interface Permission {
  id: string;
  name: string;
  displayName: string;
  description: string | null;
  resource: string;
  action: string;
  isActive: boolean;
}

interface AdminPermissionModalProps {
  permission: Permission | null;
  isEditing: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export const AdminPermissionModal: React.FC<AdminPermissionModalProps> = ({
  isEditing,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-background-primary rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b border-border-primary">
          <h2 className="text-xl font-semibold text-text-primary">
            {isEditing ? 'Edit Permission' : 'Create Permission'}
          </h2>
          <button
            onClick={onClose}
            className="text-text-secondary hover:text-text-primary transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          <p className="text-text-secondary">
            Permission {isEditing ? 'editing' : 'creation'} form will be implemented here.
          </p>
        </div>

        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border-primary">
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};
